import styled from '@emotion/styled';
import { useContext } from 'react';
import { DoubtsAIContext } from '@context/DoubtsAIContext';
import { segment } from '@actions/analytics';
import { DOW2_CONTINUE_CHAT_CLICKED } from '@constants/segment';

const BaseButton = styled.button`
  width: 172px;
  height: 42px;
  border-radius: 4px;
  padding: auto;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0%;
  border: 1px solid var(--color-divider);
  cursor: pointer;
`;

const HorizontalDivider = styled.div`
  width: 16px;
`;

const QuestionOptionsButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const ContinueChatButton = styled(BaseButton)`
  background-color: transparent;
  color: var(--color-text-primary);
`;

const NewQuestionButton = styled(BaseButton)`
  background-color: var(--color-base-fill);
  color: var(--color-text-tertiary);
`;
const QuestionOptions = () => {
  const { setFlowType, setIsAskNewQuestion, doubtNumber } =
    useContext(DoubtsAIContext);

  const handleContinueChat = () => {
    setFlowType('input');
    segment.track(DOW2_CONTINUE_CHAT_CLICKED, {
      doubt_type: 'Doubts AI',
      doubt_id: 'NA',
      ai_doubt_number_of_day: doubtNumber
    });
  };
  const handleNewQuestion = () => {
    setIsAskNewQuestion(true);
  };

  return (
    <QuestionOptionsButtonGroup>
      <ContinueChatButton onClick={handleContinueChat}>
        Continue chat
      </ContinueChatButton>
      <HorizontalDivider />
      <NewQuestionButton onClick={handleNewQuestion}>
        Ask a new question
      </NewQuestionButton>
    </QuestionOptionsButtonGroup>
  );
};

export default QuestionOptions;
